import React from 'react';
import ReactDOM from 'react-dom/client';

import {
  RouterProvider,
} from 'react-router-dom';

import {
  Provider,
} from 'react-redux';

import router from './router';
import store from './store';

import {
  AuthProvider,
} from './contexts/AuthContext';


const root =
  ReactDOM.createRoot(
    document.getElementById('root')
  );


root.render(
  <React.StrictMode>

    <Provider store={store}>

      <AuthProvider>

        <RouterProvider
          router={router}
        />

      </AuthProvider>

    </Provider>

  </React.StrictMode>
);